import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../shared/app.config';
import { IConsolidatedReq } from './state';
import { Observable } from 'rxjs';
import { BasicAuthConfig } from '@roosevelt/common-ui-lib/core';

@Injectable({
  providedIn: 'root'
})
export class ReportsApiService {

  constructor(private readonly http: HttpClient, private readonly config: AppConfig, private readonly internalAuth: BasicAuthConfig) {
  }


  getODNotice(req) {
    return this.http.post<any>(this.config.overageDependentNoticeUrl, req);
  }

  getDocument(req): Observable<any> {
    const url = this.config.overageDependentNoticeDocUrl + req.id;
    if (this.internalAuth.authedUrls.indexOf(url) === -1) {
      this.internalAuth.authedUrls = [...this.internalAuth.authedUrls, url];
    }
    return this.http.get(url, { observe: 'body', responseType: 'arraybuffer' });
  }

  getAdhocReport(req) {
    return this.http.post(this.config.adhocReportUrl, req, {
      headers: { accept: 'application/vnd.ms-excel' },
      observe: 'body',
      responseType: 'arraybuffer'
    });
  }

  getConsolidatedReport(req: IConsolidatedReq) {
    return this.http.post(this.config.consolidatedReportUrl, req, {
      headers: { accept: 'application/vnd.ms-excel' },
      observe: 'body',
      responseType: 'arraybuffer'
    });
  }

  getCustomGroupReport(req) {
    return this.http.post<any>(this.config.customGroupReportUrl, req);
  }
}
